import {AddToCartButton, useProductOptions} from '@shopify/hydrogen';
import {useState} from 'react';
import {Button} from '~/components/global/Button.client';
import {QuantityPicker} from '~/components/global/QuantityPicker.client';
import {useToast} from '~/hooks/useToast';
import OnScreenModal from '../global/OnScreenModal.client';

export function ProductActions() {
  // The useProductOptions hook returns an object that enables you to keep track of the selected variant
  const {selectedVariant} = useProductOptions();
  const isOutOfStock = !selectedVariant?.availableForSale || false;
  const [quantity, setQuantity] = useState(1);
  const {handleCartTotalChange} = useToast();
  const [modalOpen, setModalOpen] = useState(false);
  const [isSubscribed, setIsSubscribed] = useState(false);
  // breifly show the cart overlay after adding an item to the cart on desktop
  const toggleCartOverlayVisibility = () => {
    const cartOverlay = document?.querySelector('.cart-overlay');

    if (cartOverlay) {
      cartOverlay.classList.add('active');
      setTimeout(function () {
        cartOverlay.classList.remove('active');
      }, 3000);
    }
  };
  const closeModal = () => {
    setModalOpen(false);
    setIsSubscribed(true);
  };

  return (
    <>
      {isOutOfStock ? (
        <p className="sold-out" onClick={() => setModalOpen(true)}>
          {isSubscribed
            ? 'We will notify you when back in stock.'
            : 'Notify me when back in stock!'}
        </p>
      ) : (
        <>
          <h5>Quantity:</h5>
          <div className="product-actions">
            <div className="product-actions__picker">
              <QuantityPicker callback={setQuantity} quantity={quantity} />
            </div>
            <div className="product-actions__add-to-cart">
              <AddToCartButton
                variantId={selectedVariant?.id}
                quantity={quantity}
                accessibleAddingToCartLabel="Adding item to your cart"
                disabled={isOutOfStock}
                type="button"
                onClick={() => {
                  handleCartTotalChange(quantity);
                  toggleCartOverlayVisibility();
                  setQuantity(1);
                }}
              >
                <Button ctaText="Add To Cart" variant="dark" />
              </AddToCartButton>
            </div>
          </div>
        </>
      )}
      {modalOpen && (
        <OnScreenModal
          variantId={selectedVariant.id}
          onClose={() => closeModal()}
        />
      )}
    </>
  );
}
